import React, {useEffect, useMemo, useState} from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import Chart from 'react-apexcharts';
import 'react-datepicker/dist/react-datepicker.css';
import ApiUtils from 'api/ApiUtils';

const MostPopularEvents = (): any => {
  // const [startDate, setStartDate] = useState(new Date());
  // const selectedYear = moment(startDate).format('YYYY');
  const [cardData, setCardData]: any = useState<any[]>([]);
  console.log('🚀 ~ MostPopularEvents ~ cardData:', cardData);

  // const [activeChart, setActiveChart] = useState<string>('');
  // const inputRef: any = useRef(null);
  // const inputRefByYear: any = useRef(null);

  const fetchDasboardData = async (): Promise<void> => {
    const resp: any = await ApiUtils.getMostPopularEventData();

    setCardData(resp.data);
  };

  useEffect(() => {
    void fetchDasboardData();
  }, []);

  const {events, series}: any = useMemo(() => {
    const extractedEvents: number[] = [];
    const extractedCounts: number[] = [];

    cardData?.forEach((element: any) => {
      extractedEvents.push(element.event_name);
      extractedCounts.push(element.guest_count);
    });

    return {
      events: extractedEvents,
      series: [
        {
          name: 'Guestlist sign-up',
          // data: cardData?.map((data: any) => {
          //   return data.count;
          // }),
          data: extractedCounts,
        },
      ],
    };
  }, [cardData]);

  console.log('EVENTS!!!!!', events);

  const options: any = {
    chart: {
      height: 400,
      // type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Most Popular Events (by guestlist sign-ups)`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },

    xaxis: {
      categories: events,
    },
  };

  return (
    <Col xxl={12} className="order-last">
      <Card>
        <Card.Header className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1 text-start">
            Most Popular Events
          </h4>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xxl={12}>
              <Chart
                options={options}
                series={series}
                type="bar"
                height="405"
                className="apex-charts"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default MostPopularEvents;
